import { CustomDetector } from 'i18next-browser-languagedetector';

import { getStoredOrDefaultCulture } from './user';

export const prismaLanguageDetector: CustomDetector = {
  name: 'prisma language detector',

  lookup() {
    const { culture } = getStoredOrDefaultCulture();
    return culture;
  },

  cacheUserLanguage() {
    // Language caching is handled separately by localisation-adapter.ts, so no additional caching is needed here.
  },
};
